export default {
  apiUri: process.env.VUE_APP_API_URL,
  baseUri: process.env.VUE_APP_BASE_URL
}